import { pickBy, identity } from 'lodash/fp';
export var compactObject = pickBy(identity);
export default compactObject;